import { AppContext } from '@ctsu/loader';
import {
  getUserTypeWithCtepIdFromStorage,
  moveItemToTop,
  setUserTypeToStorage
} from 'helper/utils';
import { head } from 'ramda';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { useCurrentUserCtepId } from 'Hooks';

function Picker({ options }) {
  const [selectedOption, setSelectedOption] = useState(head(options));

  const currentUserCtepId = useCurrentUserCtepId();
  const appendCtepId = '=' + currentUserCtepId;
  useEffect(() => {
    let localStorageUserType;
    let localStorageUserCtepId;
    const localStorageUserTypeArray = getUserTypeWithCtepIdFromStorage();

    if (
      Array.isArray(localStorageUserTypeArray) &&
      localStorageUserTypeArray.length >= 2
    ) {
      localStorageUserType = localStorageUserTypeArray[0];
      localStorageUserCtepId = localStorageUserTypeArray[1];
    }
    // Compare localStorage Ctep ID and the session CTEP id, if not equal always get the head value for the current user
    const areCtepIdsEqual =
      localStorageUserCtepId?.toString() === currentUserCtepId?.toString();
    if (
      localStorageUserType &&
      areCtepIdsEqual &&
      options?.indexOf(localStorageUserType) > -1
    ) {
      setSelectedOption(localStorageUserType);
      setUserTypeToStorage(localStorageUserType + appendCtepId);
    } else if (options?.length > 0) {
      setUserTypeToStorage(head(options) + appendCtepId);
    }
  }, [options]);

  function handleChange(option, event) {
    if (event.action === 'select-option') {
      setUserTypeToStorage(option.value + appendCtepId);
      window.location.reload();
    }
  }

  return (
    <form
      data-testid="usertype-picker"
      className={`mr-2 ${options.length > 1 ? '' : 'd-none'}`}
    >
      <label className="invisible" htmlFor="user-type-picker">
        User type
      </label>
      <Select
        className="reactSelect-wrapper reactSelect-roleSelect-wrapper"
        classNamePrefix="reactSelect"
        value={{ label: selectedOption, value: selectedOption }}
        inputId="user-type-picker"
        name="user-type"
        options={options?.map((ut) => ({ label: ut, value: ut })) || []}
        onChange={(option, event) => handleChange(option, event)}
        menuPortalTarget={document.body}
        placeholder="Select..."
        isSearchable
      />
    </form>
  );
}

export default function UserTypePicker() {
  const context = useContext(AppContext);
  const { session } = context;
  const { userTypes = [] } = session || [];
  const userTypeOptions = useMemo(() => {
    if (Array.isArray(userTypes) && userTypes.length > 0) {
      return moveItemToTop(userTypes, 'LPO');
    }
    return [];
  }, [userTypes]);

  return <Picker options={userTypeOptions} />;
}
